<div class="pumpOrCTContainer" [ngClass]="selectedEquipData.class" [ngStyle]="{'height': rightContainerHeight.height, 'overflow': rightContainerHeight['overflow']}" id="pumpOrCT">
  @if ((selectedEquipData.class == 'pump1Vertical_forward') || selectedEquipData.class.includes('pump1Vertical_backward') || (this.selectedEquipData.class == 'coolingTowerSingleFan')) {
    @if ((dataset['VFD_Speed']?.length || dataset['VFD_Speed_Feedback']?.length)) {
      <div class="circular-main-div">
        <div id="circularGraph-clickView" class="circularChart-clicked-view">
        </div>
        <div id="graphHeaderText" class="graphPointHeader">
          @if (dataset['VFD_Speed']?.length) {
            VFD SPEED
          }
          @if (dataset['VFD_Speed']?.length && dataset['VFD_Speed_Feedback']?.length) {
            |
          }
          @if (dataset['VFD_Speed_Feedback']?.length) {
            FEEDBACK
          }
          <div>
            @if (dataset['VFD_Speed']?.length) {
              <div class="VFDDropDownContainer">
                <div class="d-flex">
                  <mat-select [disabled]="loginUserTypeData?.isPublic || loginUserTypeData?.isVofm"  [ngClass]="{'sharedMatDropDown': loginUserTypeData?.isPublic, 'mat-select-open': VFDDropdownOpen}" class="vfd-select" id="mySelect-pump" (selectionChange)="onChange($event, this.selectedPoint)"
                    [(ngModel)]="selectValue" (openedChange)="VFDDropdownOpen = $event" >
                    @for (option of options['VFDSpeed']; track option) {
                      <mat-option class="hide-checkbox" [value]="option">
                        {{option}}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            }
            @if (dataset['VFD_Speed_Feedback']?.length) {
              <span class="graphPointValText outer-chart-color">{{dataset['VFD_Speed_Feedback'][0]['value'] +
              ' ' + dataset['VFD_Speed_Feedback']?.[0]?.['unit']}}</span>
            }
          </div>
        </div>
      </div>
    }
  }
  @if ((selectedEquipData.class == 'coolingTowerFourFan') || (selectedEquipData.class == 'coolingTowerTwoFan')) {
    @for (item of mulitpleCTFans; track item; let i = $index) {
      @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeed']?.length || dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeedFeedback']?.length) {
        <div class="circular-main-div-multi" [id]="'circular-main-div-multi-'+item">
          <div class="sub-section">
            <div [id]="'circularGraph-clickView-' + item" class="circularChart-clicked-view">
            </div>
            <div [id]="'graphHeaderText-'+ item" class="graphPointHeader">
              <div class="multipleChartSubText">FAN {{item}}</div>
              @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeed']?.length) {
                VFD SPEED
              }
              @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeed']?.length && dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeedFeedback']?.length) {
                |
              }
              @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeedFeedback']?.length) {
                FEEDBACK
              }
              <div>
                @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeed']?.length) {
                  <div class="VFDDropDownContainer">
                    <div class="d-flex">
                      <mat-select [disabled]="loginUserTypeData?.isPublic"  [ngClass]="{'sharedMatDropDown': loginUserTypeData?.isPublic, 'mat-select-open': VFD1DropdownOpen[i] }" class="vfd-select" [id]="'mySelect-pump-'+item"
                        (selectionChange)="onMultipleChange($event, item)"
                        [(ngModel)]="multipleVfdSelection[item]" (openedChange)="VFD1DropdownOpen[i] = $event">
                        @for (option of options[item]; track option) {
                          <mat-option class="hide-checkbox" [value]="option">
                            {{option}}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </div>
                }
                @if (dataSetObjOfArr['CoolingTowerFan#'+item+'VFDSpeedFeedback']?.length) {
                  <span
                  class="graphPointValText outer-chart-color">{{generateVFDFeedBackValue(item)}}</span>
                }
              </div>
            </div>
          </div>
        </div>
      }
    }
  }
</div>